import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Card from '../../card/card';
import cloneDeep from 'lodash/cloneDeep';
import FCSlider from '../../fc_slider/fc_slider';
import generateTagData from '../../../../utils/advertorial_utils';
import {
  isAdvertorial,
  isPremium
} from '../../../../views/components/advertorial/advertorial';
import log from '../../../../services/logger_service';
import Cookies from 'js-cookie';
import MobileVideoPlayer from '../../mobile_video_module/mobile_video_module_reactjw';
import { trackGAEvent } from '../../../../client/utils/third_party_trackers/ga';
import AccordionGallery from '../../accordion_gallery/accordion_gallery';
import { UserConsumer } from '../../../components/context/userContext';
import AdContainer from '../../ad/AdContainer';
import BottomSticky from '../utils/BottomSticky';
import BlueConicPremiumPaywall from '../../BlueConicPremiumPaywall/BlueConicPremiumPaywall';
import clsx from 'clsx';

/* eslint no-nested-ternary: 0 */

class Article extends Component {
  constructor() {
    super();
    this.state = {
      midArticleInjection: null,
      alwaysOn: null,
      hideMobileVideoPlayer: false,
      showGlobalPlayer: null,
      // mobileAdhesiveUnitShouldShow: Math.random() > 0.25 // Show only 75% of the time - excluding redesign article
      mobileAdhesiveUnitShouldShow: true // Show 100% of time for now
    };

    this.renderNativeAlwaysOn = this.renderNativeAlwaysOn.bind(this);
    this.hideMobileVideoPlayer = this.hideMobileVideoPlayer.bind(this);
    this.checkPaidCampaign = this.checkPaidCampaign.bind(this);

    this.isMobile = false;
    this.showPlayer = false; // Remove once debugged.
    this.showDesktopBillboard = true; // Hard/static display boolean for ad purposes
    this.showLiveBanner = false;

    this.parsLoaded = 0;
    this.utmCode = '';
    this.campaignsArr = [
      '?utm_source=google&utm_medium=ppc&utm_campaign=keywee',
      '?utm_source=facebook&utm_medium=ppc&utm_campaign=keywee'
    ];
  }

  componentDidMount() {
    this.checkWindowSize();
    this.utmCode = window.location.search || '';
    // window.addEventListener('resize', this.checkWindowSize.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (isAdvertorial(get(nextProps, 'post.tags'))) {
      return;
    }

    if (
      !this.state.midArticleInjection &&
      get(nextProps, 'postNativeAd.length')
    ) {
      const modifiedInjectionArticle = get(nextProps, 'postNativeAd[0]');
      const advertiserData = generateTagData(
        get(modifiedInjectionArticle, 'tags')
      );

      modifiedInjectionArticle.customEyebrowText = get(
        advertiserData,
        'advertiser'
      );

      this.setState({
        midArticleInjection: [modifiedInjectionArticle]
      });
    }
  }

  setPostChunk(chunkOriginal, index, totalChunkLength, id, showDrawer) {
    const chunk = [...chunkOriginal];
    const self = this;
    const { post, advertorial } = this.props;
    const chunks = get(post, 'content', []);
    const paywallViewLimit = 2; // SHOULD BE DYNAMIC FROM JOURNEY ULTIMATELY!!!
    const isPremiumArticle = isPremium(get(post, 'tags', []));
    let chunkingStopped = get(this, 'chunkingStopped', false);
    let currentParCount = get(this, 'parsLoaded', 0);
    const podcastEmbedIndex = get(post, 'categories', []).findIndex(
      category => typeof category.podcastEmbed !== 'undefined'
    );
    if (index === Math.floor(totalChunkLength / 3)) {
      const podcastChunk = get(
        post,
        `categories[${podcastEmbedIndex}].podcastEmbed`,
        ''
      );

      // chunk.splice(podcastChunk);
      chunk.push(podcastChunk);
    }

    // Resetting paragraph counter and chunking flag between renders
    if (index === 0) {
      currentParCount = 0;
      this.chunkingStopped = false;
      chunkingStopped = false;
    }
    const paywallLimitReached =
      showDrawer && chunk.length + currentParCount > paywallViewLimit;

    if (chunkingStopped && !advertorial) {
      return null;
    }

    // Strip paragtraphs that go over paywall limit
    if (paywallLimitReached && !advertorial) {
      const toRemove = chunk.length + currentParCount - paywallViewLimit - 1;
      chunk.splice(chunk.length - toRemove, toRemove);
      this.chunkingStopped = true;
    } else {
      this.parsLoaded = currentParCount + chunk.length;
    }

    const midArticleInjection =
      this.state.midArticleInjection &&
      index === Math.floor(totalChunkLength / 2)
        ? this.state.midArticleInjection.map(article => (
            <div
              className="native-injection"
              key={`native-injection-${article.id}`}
            >
              <Card
                config={this.props.config}
                type="injection"
                metadata={article}
                key={article.id}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: 'nativeMidArticleInjection',
                    eventLabel: get(article, 'title')
                  });
                }}
              />
            </div>
          ))
        : '';

    const alwaysOnInjection =
      this.state.alwaysOn && index === Math.floor(totalChunkLength / 2)
        ? this.state.alwaysOn
        : '';

    let midPosition = Math.ceil(chunk.length / 2);
    const preventWithOtherInjections = false;

    // Handles if the chunk contains a header, we dont want to insert it right after the header
    if (
      chunk[midPosition - 1] &&
      (chunk[midPosition - 1].includes('<h2>') ||
        chunk[midPosition - 1].includes('<h3>'))
    ) {
      midPosition = Math.floor(chunk.length / 2 + 1);
    }

    if (
      // this.showPlayer === true && // Un-comment this line disable entirely!
      this.props.pageNum === 0 &&
      // change this number to determine where the mobile sticky player shows up in the article:
      index === 1 &&
      this.isMobile &&
      // !Cookies.get('fc_rev_content') &&
      !Cookies.get('hideMobileVideoPlayer') &&
      !this.state.hideMobileVideoPlayer
    ) {
      const markupFirstHalf = [...chunk.slice(0, 1)].join('');
      const markupSecondHalf = [...chunk.slice(1, chunk.length)].join('');

      if (
        (chunks.join('').indexOf('video-wrapper') !== -1 &&
          preventWithOtherInjections) ||
        this.checkPaidCampaign(this.utmCode, this.campaignsArr)
      ) {
        return (
          // RETURN WITHOUT MOBILE VIDEO INSERT IF THERE IS A VIDEO IN THE ARTICLE
          <Fragment key={`chunk-${index}`}>
            <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
            {this.state.showGlobalPlayer !== null && (
              <div>{this.state.showGlobalPlayer}</div>
            )}
            <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
          </Fragment>
        );
      }

      return (
        // return WITH mobile video insert because there is no video in the article...
        // we just dont want a video ad to appear if there is a video in the article already
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {this.state.showGlobalPlayer == null &&
            this.state.mobileAdhesiveUnitShouldShow &&
            !this.props.specialRedesignArticle &&
            !isPremiumArticle && (
              <BottomSticky getAdhesiveHeight={this.props.getAdhesiveHeight}>
                <MobileVideoPlayer
                  mobileInline={true}
                  type="rightrail"
                  playerid="delVxmba"
                  // hard coded playlist for alison/jonelle
                  playlistId="5CQr0On3"
                  pos="newmultiplayer"
                  hideMobileVideoPlayer={self.hideMobileVideoPlayer}
                />
              </BottomSticky>
            )}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    const markupFirstHalf = [...chunk.slice(0, midPosition)].join('');
    const markupSecondHalf = [...chunk.slice(midPosition, chunk.length)].join(
      ''
    );

    if (
      markupFirstHalf === 'INLINE_CAROUSEL' ||
      markupFirstHalf === 'INLINE_CAROUSEL'
    ) {
      return (
        <FCSlider
          key={`inline-slideshow-${id}-${index}`}
          slideShowData={this.inlineCarousels.shift()}
          location="post__inline"
        />
      );
    }

    // just return whole chunk if there's no article injection
    if (midArticleInjection === '' && this.state.alwaysOn == null) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: chunk.join('') }} />
        </Fragment>
      );
    }

    if (midArticleInjection && alwaysOnInjection) {
      const choice = Math.floor(Math.random() * 2);
      const nativeArray = [midArticleInjection, alwaysOnInjection];

      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {nativeArray[choice]}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    if (midArticleInjection) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {midArticleInjection}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    if (alwaysOnInjection) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {alwaysOnInjection}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    return (
      <Fragment key={`chunk-${index}`}>
        <div dangerouslySetInnerHTML={{ __html: chunk.join('') }} />
      </Fragment>
    );
  }

  // Checks the window size and updates `isMobile` property
  checkWindowSize() {
    const mobileBreakpoint = 640; // in px
    this.isMobile = window.innerWidth < mobileBreakpoint;
    this.forceUpdate();
  }

  hideMobileVideoPlayer() {
    /* eslint-disable-next-line func-names */
    this.setState({ hideMobileVideoPlayer: true }, function() {
      Cookies.set('hideMobileVideoPlayer', true, { expires: 1 });
      this.forceUpdate();
    });
  }

  notAroundCarousel(chunks, currentChunk, index) {
    const next = chunks[index + 1] || [];
    const nextZeroIndex = next[0];
    const carousel = 'INLINE_CAROUSEL';

    if (nextZeroIndex === carousel || currentChunk === carousel) {
      return false;
    }

    return true;
  }

  checkPaidCampaign(utmCode, campaignsArr) {
    // return campaignsArr.includes(utmCode);
    return campaignsArr.indexOf(utmCode) > -1;
  }

  renderNativeAlwaysOn(response, index) {
    const alwaysOn = (
      <a href={response.clickthrough_url} target="_blank">
        <div
          style={{
            backgroundImage: `url(${response.bg_image})`,
            height: '180px',
            width: '100%',
            backgroundSize: 'contain',
            margin: '20px auto',
            textAlign: 'center',
            backgroundRepeat: 'no-repeat'
          }}
          className={`alwaysOn_${index}`}
        />
      </a>
    );
    this.setState({ alwaysOn });
  }

  render() {
    const { config, post, advertorial, isShortPost, insert } = this.props;

    const thePostId = get(post, 'id', 'unknown-post-id');

    const masonryCollection = get(post, 'customFields.masonry_collection', []);
    const isPremiumArticle = isPremium(get(post, 'tags', []));

    const chunks = get(post, 'content', []);
    if (!chunks.length) {
      log.error(
        'No article chunk found, this article has no body content: ',
        get(post, 'link')
      );
    }

    this.inlineCarousels = cloneDeep(get(post, 'inlineCarousels')) || [];
    const nativePixelContentArticlePageFeatureFlag = get(
      config,
      'featureFlags.nativePixelContentArticlePage'
    );

    const { isFirstPost = true } = this.props;

    let nativeAds = null;
    if (isFirstPost) {
      nativeAds = (
        <React.Fragment>
          <AdContainer type="native_link" />
          <AdContainer type="native_second_scroll" />
        </React.Fragment>
      );
    }

    const nativeAdPixel = nativePixelContentArticlePageFeatureFlag ? (
      <div>{nativeAds}</div>
    ) : (
      ''
    );

    if (post.isVideoPermalink) {
      return (
        <article className="post__article">
          <p>{post.excerpt}</p>
        </article>
      );
    }

    if (advertorial) {
      for (let i = 0; i < chunks.length; i += 1) {
        for (let j = 0; j < chunks[i].length; j += 1) {
          const regex = /<a[^>]*/gm;
          let matches;

          // eslint-disable-next-line
          while ((matches = regex.exec(chunks[i][j])) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (matches.index === regex.lastIndex) {
              regex.lastIndex += 1;
            }
            // eslint-disable-next-line no-loop-func
            matches.forEach(match => {
              chunks[i][j] = chunks[i][j].replace(
                match,
                `${match} rel="nofollow"`
              );
            });
          }
        }
      }
    }

    return (
      <UserConsumer>
        {({ isLoggedIn, isActiveSubscriber, premiumPaywallActive }) => {
          // insert is the second scroll article
          // we don't want a paywall there
          const showDrawer =
            (!isLoggedIn || !isActiveSubscriber) &&
            !insert &&
            premiumPaywallActive;
          const exceptions = new RegExp(
            // eslint-disable-next-line no-useless-escape
            /<h2|<h3|<ul|<ol|<strong|<blockquote|<iframe|<img|class=\"pullquote/,
            'gi'
          );
          // Dont show mid article inject if any of the tags above ^ are beside it:
          if (
            Array.isArray(get(chunks, '[2]')) &&
            Array.isArray(get(chunks, '[1]')) &&
            (exceptions.test(chunks[2][0]) ||
              exceptions.test(chunks[1][chunks[1].length - 1]))
          ) {
            this.showDesktopBillboard = false;
          }
          return (
            <Fragment>
              <article
                className={clsx(
                  'post__article',
                  advertorial && 'post__article--advertorial',
                  showDrawer && 'post__article--lock'
                )}
              >
                {this.showLiveBanner && (
                  <div className="fcf-live-banner">
                    <a href="https://events.fastcompany.com/innovationfestival21/keynote-pass">
                      Watch the Fast Company Innovation Festival Live now.
                    </a>
                  </div>
                )}
                {chunks.map((chunk, index) => [
                  this.setPostChunk(
                    chunk,
                    index,
                    chunks.length,
                    post.id,
                    showDrawer
                  ),
                  !isShortPost && index < chunks.length - 1 ? (
                    this.notAroundCarousel(chunks, chunk[0], index) ? (
                      this.isMobile && !isPremiumArticle ? ( // if the article is not a recommender/premium article, serve ads on mobile...
                        <div
                          key={`recommenderMobileA-${index}-for-${thePostId}`}
                        >
                          {index === 0 && (
                            <div id="fc-anyclip">
                              <AdContainer
                                key={`chunk-ad-${index}`}
                                type={isPremiumArticle ? 'rail' : 'in_content'}
                                page={isFirstPost ? 1 : 2}
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        <div
                          key={`recommenderMobileB-${index}-for-${thePostId}`}
                        >
                          {index === Math.floor(chunks.length / 2) ? ( // ... otherwise serve only 1 ad on recommender/premium articles
                            <AdContainer
                              key={`chunk-ad-${index}`}
                              type={isPremiumArticle ? 'rail' : 'in_content'}
                              page={isFirstPost ? 1 : 2}
                            />
                          ) : null}
                        </div>
                      )
                    ) : null
                  ) : null,
                  nativePixelContentArticlePageFeatureFlag &&
                    get(post, 'totalParagraphs') >= 7 &&
                    !advertorial &&
                    index === 0 && (
                      <div
                        key={`native-mid-article-inject-${index}-for-${thePostId}`}
                        className={`adInserts_${index}`}
                      >
                        {isFirstPost ? (
                          <AdContainer type="native_mid_article" />
                        ) : null}
                      </div>
                    )
                ])}
                {masonryCollection &&
                  masonryCollection.map((data, index) => (
                    <AccordionGallery
                      key={`AccordionGallery-${index}`}
                      {...data}
                    />
                  ))}
                {nativeAdPixel}
                <div
                  id="collapsible-placeholder"
                  style={{
                    width: '100%',
                    position: 'fixed',
                    bottom: '0',
                    left: '0',
                    zIndex: '9999',
                    backgroundColor: '#FFFFFF'
                  }}
                />
                {this.isMobile && (
                  <div
                    id="collapsible-mobile-video-unit"
                    style={{
                      width: '100%',
                      position: 'fixed',
                      bottom: '0',
                      left: '0',
                      zIndex: '9999',
                      backgroundColor: 'offwhite'
                    }}
                  />
                )}
              </article>
              {showDrawer && <BlueConicPremiumPaywall />}
            </Fragment>
          );
        }}
      </UserConsumer>
    );
  }
}

Article.defaultProps = {
  isFirstPost: true,
  specialRedesignArticle: false,
  getAdhesiveHeight: () => 0,
  insert: false
};

Article.propTypes = {
  advertorial: PropTypes.bool.isRequired,
  post: PropTypes.shape({}).isRequired,
  pageNum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  config: PropTypes.shape({}).isRequired,
  isShortPost: PropTypes.bool.isRequired,
  isFirstPost: PropTypes.bool,
  specialRedesignArticle: PropTypes.bool,
  getAdhesiveHeight: PropTypes.func,
  insert: PropTypes.bool
};

function mapStateToProps(state = {}) {
  const nativeAdInjectData = get(
    state,
    'postNativeAd.data.midArticleInject.posts'
  );

  if (nativeAdInjectData) {
    return {
      postNativeAd: nativeAdInjectData
    };
  }

  return {
    postNativeAd: []
  };
}

export default connect(mapStateToProps)(Article);
